export const ErrorAudioUrls = {
  already_accepted: '/audio/already_accepted_error.mp3',
  open_box_error: '/audio/different_branch_error.mp3',
  null_list: '/audio/null_list_error.wav',
  declared: '/audio/declared.mpga',
  undeclared: '/audio/undeclared.mp3',
  success: '/audio/success.mp3',
  user_changed: '/audio/user_changed.mp3',
  fail: '/audio/error.mp3',
};
